
function darkThemeFix_overrideBazaarViewColors(parent, targetsAndStyleArray, deleteAfterUse) {
  let parentType = parent[0];
  let elements = [];
  if (parentType === '#') {
    let one = document.getElementById(parent.substring(1));
    elements = [one];
  } else {
    elements = document.getElementsByClassName(parent.substring(1));
  }
  for (let i = 0; i < elements.length; i++) {
    let observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node && node.nodeType === Node.ELEMENT_NODE) {
              for (let m = 0; m < targetsAndStyleArray.length; m++) {
                let iter = targetsAndStyleArray[m];
                let elTargetsForColor = [];
                let targetStr = iter[0];
                let forcedStyle = iter[1];
                let forcedValue = iter[2];
                let targetsArr = targetStr.split(" ");
                for (let j = 0; j < targetsArr.length; j++) {
                  let jT = targetsArr[j];
                  if (jT[0] === "#") {
                    // console.log(node);
                    let tmp = document.getElementById(jT.substring(1));
                    if (tmp !== null) {
                      elTargetsForColor.push(tmp);
                    }
                  } else {
                    let tmps = node.getElementsByClassName(jT.substring(1));
                    elTargetsForColor = elTargetsForColor.concat(Array.from(tmps));
                  }
                }
                for (let k = 0; k < elTargetsForColor.length; k++) {
                  let elem = elTargetsForColor[k];
                  elem.style.setProperty(forcedStyle, forcedValue, 'important');
                }
              }
            }
          }
        }
      }
      if (deleteAfterUse) {
        observer.disconnect();
      }
    });

    let target = elements[i];
    observer.observe(target, { childList: true, subtree: true });
  }
}

// darkThemeFix_overrideBazaarViewColors(".bv-inline-rating", [[".bv_text", "color", "white"]], true);